import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import WizardPaso2 from '../components/WizardPaso5';
import { useAppAgendaContext } from '../context/AppAgendaContext';
import { logEventoBD } from '../services/api/authService';

const getDoctorImage = (odontRut) => {
  const imagePath = `/agenda/images/imgdocs/${odontRut}.jpg`;
  const defaultImagePath = `/agenda/images/imgdocs/sin_foto.jpg`;

  const image = new Image();
  image.src = imagePath;
  return image.complete ? imagePath : defaultImagePath;
};

const ConfirmaPaciente = () => {
  useEffect(() => {
    const paso = "ConfirmaPaciente";

    // Validación de seguridad del flujo
    if (!validarPaso(paso)) {
      registrarEventoVisual({
        paso,
        evento: "flujo_bloqueado",
        descripcion: "Intento de acceso no autorizado.",
      });
      window.location.href = "/";
      return;
    }

    // Si pasa la validación, registrar el dato en BD
    setPasoActual(paso);
    logEvento({
      paso: 'ConfirmaPaciente',
      evento: 'carga_pagina',
      descripcion: 'Usuario accede al paso ConfirmaPaciente'
    });

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "paso_confirma_paciente" });
    setUltimoEventoGTM("paso_confirma_paciente");
    agregarPasoPermitido(paso);
  }, []);

  const navigate = useNavigate();
  const {
    contextData,
    updatePacienteInfo,
    setPasoActual,
    setUltimoEventoGTM,
    registrarEventoVisual,
    validarPaso,
    agregarPasoPermitido,
    logEventoBD
  } = useAppAgendaContext();

  const [nombre, setNombre] = useState('');
  const [telefono, setTelefono] = useState('');
  const [email, setEmail] = useState('');
  const originalNombre = contextData.pacienteInfo?.pacNombre || '';
  const originalTelefono = contextData.pacienteInfo?.pacTelefono || '';
  const originalEmail = contextData.pacienteInfo?.pacCorreo || '';
  const [formattedDate, setFormattedDate] = useState('');
  const [formattedTime, setFormattedTime] = useState('');
  const doctorImageSrc = getDoctorImage(contextData.odontRut);

  const logEvento = async ({ paso, evento, descripcion, campo, valor }) => {
    try {
      await logEventoBD({
        paso,
        evento,
        descripcion,
        campo,
        valor,
        sessionId: contextData?.sessionId,
        contextData,
        utmData: contextData?.utmData || {},
        flujoActivo: 'ConfirmaPaciente'
      });
    } catch (error) {
      console.error("Error enviando evento a producción:", error);
    }
  };

  useEffect(() => {
    if (contextData.pacienteInfo) {
      setNombre(contextData.pacienteInfo.pacNombre || '');
      setTelefono(contextData.pacienteInfo.pacTelefono || '');
      setEmail(contextData.pacienteInfo.pacCorreo || '');
    }

    if (contextData.selectedDateTime) {
      const [date, time] = contextData.selectedDateTime.split(' ');
      /* const dateParts = date.split('-');
      const parsedDate = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]); */
      const parsedDate = new Date(`${date}T00:00:00`);

      const options = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' };
      const formattedDate = parsedDate.toLocaleDateString('es-ES', options);
      setFormattedDate(formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1));
      setFormattedTime(time);
    }
  }, [contextData, contextData.selectedDateTime]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    await logEvento({
      paso: 'ConfirmaPaciente',
      evento: 'click_siguiente',
      descripcion: 'Usuario presionó Siguiente en ConfirmaPaciente'
    });

    // Actualizar los datos en el contexto
    updatePacienteInfo({ pacNombre: nombre, pacCorreo: email, pacTelefono: telefono });

    // Navegar a la siguiente página
    navigate('/ConfirmaAgendamiento');
  };

  return (
    <Container>
      <WizardPaso2 />
      <Content>
        <Title>¡Ya casi terminas!</Title>
        <Subtitle>Completa tus datos para enviar tu reserva de hora</Subtitle>

        <Form onSubmit={handleSubmit}>
          <Row>
            <Col>
              <Label className="label-text"><strong>Nombre</strong></Label>
              <input
                type="text"
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
                onBlur={() => {
                  const fueModificado = nombre !== originalNombre;

                  registrarEventoVisual({
                    paso: 'ConfirmaPaciente',
                    evento: 'nombre_ingresado',
                    descripcion: `Nombre ingresado: ${nombre}${fueModificado ? ' (modificado)' : ' (sin cambios)'}`
                  });

                  logEvento({
                    paso: 'ConfirmaPaciente',
                    evento: 'nombre_ingresado',
                    descripcion: fueModificado ? 'Nombre modificado por el usuario' : 'Nombre sin cambios',
                    campo: 'nombre',
                    valor: nombre
                  });
                }}               
                placeholder="Nombre completo"
                required
                style={{
                  width: '100%',
                  height: '40px',
                  border: '1px solid #00788C',
                  borderRadius: '0.25rem',
                  padding: '10px',
                  fontSize: '16px'
                }}
              />
            </Col>
            <Col>
              <Label className="label-text"><strong>Teléfono</strong></Label>
              <div style={{
                display: 'flex',
                width: '100%',
                height: '40px',
                border: '1px solid #00788C',
                borderRadius: '0.25rem',
                overflow: 'hidden',
                backgroundColor: '#fff'
              }}>
                <div style={{
                  backgroundColor: '#E9F6F7',
                  padding: '0 12px',
                  fontSize: '15px',
                  color: '#00788C',
                  display: 'flex',
                  alignItems: 'center',
                  fontWeight: 500,
                  gap: '6px'
                }}>
                  <i className="fas fa-phone-alt" style={{ fontSize: '13px' }}></i>
                  +56 9
                </div>
                <input
                  type="text"
                  value={telefono}
                  onChange={(e) => {
                    const input = e.target.value.replace(/\D/g, '').slice(0, 8);
                    setTelefono(input);
                  }}
                  onBlur={() => {
                    const fueModificado = telefono !== originalTelefono;

                    registrarEventoVisual({
                      paso: 'ConfirmaPaciente',
                      evento: 'telefono_ingresado',
                      descripcion: `Teléfono ingresado: ${telefono}${fueModificado ? ' (modificado)' : ' (sin cambios)'}`
                    });

                    logEvento({
                      paso: 'ConfirmaPaciente',
                      evento: 'telefono_ingresado',
                      descripcion: fueModificado ? 'Teléfono modificado por el usuario' : 'Teléfono sin cambios',
                      campo: 'telefono',
                      valor: telefono
                    });
                  }}
                  placeholder="12345678"
                  maxLength="8"
                  required
                  style={{
                    border: 'none',
                    borderLeft: '1px solid #00788C',
                    borderRadius: '0',
                    flex: 1,
                    height: '100%',
                    paddingLeft: '12px'
                  }}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <ColFull>
            <Label className="label-text"><strong>Email</strong></Label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onBlur={() => {
                  const fueModificado = email !== originalEmail;

                  registrarEventoVisual({
                    paso: 'ConfirmaPaciente',
                    evento: 'email_ingresado',
                    descripcion: `Correo ingresado: ${email}${fueModificado ? ' (modificado)' : ' (sin cambios)'}`
                  });

                  logEvento({
                    paso: 'ConfirmaPaciente',
                    evento: 'email_ingresado',
                    descripcion: fueModificado ? 'Correo modificado por el usuario' : 'Correo sin cambios',
                    campo: 'correo',
                    valor: email
                  });
                }}               
                placeholder="email@dominio.com"
                required
                style={{
                  width: '100%',
                  height: '40px',
                  border: '1px solid #00788C',
                  borderRadius: '0.25rem',
                  padding: '10px',
                  fontSize: '16px'
                }}
              />
            </ColFull>
          </Row>

          <div className="alert alert-info" role="alert">
            <DoctorInfo>
              <DoctorImage src={doctorImageSrc} alt={`Foto de Dr. ${contextData.doctorName}`} />
              <DoctorDetails>                
                <DoctorName><strong>{contextData.doctorName || 'Sin información'}</strong></DoctorName>
                <Specialty>{'Agendamiento Online' || 'Sin información'}</Specialty>
              </DoctorDetails>
              <AppointmentDetails>
                <StyledDate>{formattedDate || 'Sin información'}</StyledDate>
                <LocationTime>
                  <strong>
                    <i className="fas fa-map-marker-alt" /> Sucursal: {contextData.sucursalNombre || 'Sin información'}
                  </strong>
                  &nbsp; - &nbsp;
                  <strong>
                    <i className="fas fa-clock" /> {formattedTime || 'Sin información'}
                  </strong>
                </LocationTime>
              </AppointmentDetails>
            </DoctorInfo>
          </div>

          <ButtonGroup>
            <Button type="button" secondary onClick={() => navigate('/SeleccionaFecHora')}>
              Volver
            </Button>
            <Button type="submit">Siguiente</Button>
          </ButtonGroup>
        </Form>
      </Content>
    </Container>
  );
};

// Styled Components
const Container = styled.div`
  max-width: 800px;
  width: 100%;
  margin: 40px auto;
  padding: 30px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
`;

const Content = styled.div`
  padding: 20px;
`;

const Title = styled.h3`
  text-align: center;
  color: #00cfd4;
  margin-bottom: 10px;
`;

const Subtitle = styled.h4`
  text-align: center;
  color: #6c757d;
  margin-bottom: 30px;
`;

const Form = styled.form`
  margin-top: 30px;
`;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap; /* Permite salto de línea */
  justify-content: space-between;
  margin-bottom: 20px;
`;

const Col = styled.div`
  flex: 1;
  margin-right: 10px;

  &:last-child {
    margin-right: 0;
  }

  @media (max-width: 768px) {
    flex: 100%;
    margin-right: 0;
    margin-bottom: 15px;
  }
`;

const ColFull = styled.div`
  flex: 1;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
`;

const Input = styled.input`
  width: 100%;
  padding: 10px;
  border: 1px solid #ced4da;
  border-radius: 5px;
  font-size: 16px;
`;

const DoctorInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
  }
`;

const DoctorImage = styled.img`
  height: 80px;
  width: 80px;
  border-radius: 50%;

  @media (max-width: 768px) {
    display: none; 
  }
`;

const DoctorDetails = styled.div`
  margin-left: 15px;
  text-align: start;
`;

const Specialty = styled.p`
  font-weight: bold;
  color: #00cfd4;
  margin: 0;
`;

const DoctorName = styled.p`
  margin: 0;
`;

const AppointmentDetails = styled.div`
  margin-left: auto;
  text-align: end;
`;

const StyledDate = styled.div`
  font-weight: bold;
`;

const LocationTime = styled.div`
  font-size: 14px;
  color: #6c757d;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
`;

const Button = styled.button`
  background-color: ${(props) => (props.secondary ? '#fff' : '#00cfd4')};
  border: ${(props) => (props.secondary ? '1px solid #6c757d' : 'none')};
  border-radius: 20px;
  color: ${(props) => (props.secondary ? '#6c757d' : '#fff')};
  cursor: pointer;
  font-size: 16px;
  padding: 10px 20px;
  min-width: 150px;
  transition: all 0.3s ease;

  &:hover {
    background-color: ${(props) => (props.secondary ? '#f8f9fa' : '#00bfc4')};
  }
`;

export default ConfirmaPaciente;
